import React from 'react';
const images = ['https://cdn.magicpatterns.com/uploads/kXpVrc4kFykriyoFwWDxkQ/carrusel_3.jpg', 'https://cdn.magicpatterns.com/uploads/vdeDyxESwB5JbZgZCfNBeq/carrusel_4.jpg', 'https://cdn.magicpatterns.com/uploads/uFy89FxUUY6diSQRckna1N/carrusel_5.jpg', 'https://cdn.magicpatterns.com/uploads/6tyBGPXE1LSgsUtZxERZJ6/carrusel_6.jpg', 'https://cdn.magicpatterns.com/uploads/hqGPV9QeBQ84RNWtMUheA1/carrusel_7.jpg', 'https://cdn.magicpatterns.com/uploads/eML6rD22YJ2krS3KsVpnw5/carrusel_8.jpg', 'https://cdn.magicpatterns.com/uploads/p9eCGxnPDzH36xbAcxxB2Y/carrusel_9.jpg', 'https://cdn.magicpatterns.com/uploads/tDZefsvYpJkcgBzyA2gMBP/carrusel_10.jpg'];
export function Carousel() {
  const track = [...images, ...images];
  return <section className="bg-deco-beige py-6 sm:py-8 overflow-hidden" aria-label="Galería de piezas creadas con falso vitral" data-id="element-43" data-mp="23m19giplk226">
      <style data-id="element-44" data-mp="3ezmy82rjo1n6">{`
        @keyframes deco-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .deco-marquee-track {
          animation: deco-marquee 45s linear infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .deco-marquee-track { animation: none; }
        }
      `}</style>

      <div className="flex w-max deco-marquee-track" data-id="element-45" data-mp="2qylgm8f6wyy8">
        {track.map((src, i) => <div key={i} className="w-32 h-32 sm:w-44 sm:h-44 mx-1.5 sm:mx-2 rounded-2xl overflow-hidden shrink-0 border border-deco-forest/8" data-id="element-46" data-mp="2uzozl3sjbb3o" data-mpi={i}>
            <img src={src} alt="" aria-hidden="true" className="w-full h-full object-cover" data-id="element-47" data-mp="23bdhy9c9oo56" />
          </div>)}
      </div>
    </section>;
}